import axios from "axios";

import { apiUrl } from "@/utils/helpers";
import { VerifyUserKyc } from "./verify-user-kyc.types";

const path = "/api/userverification/kyc_no_auth";

export const verifyUserKyc = async (kycData: {}) => {
  const { data } = await axios.post(apiUrl(path), kycData);

  return data as VerifyUserKyc;
};
